module.exports = __webpack_public_path__ + "static/media/squidsalad.724b0b82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/squidsalad.jpg
// module id = 136
// module chunks = 0